import { useQueries, useQuery } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";

type SearchParams = {
  query?: string;
  tags?: string[];
};

const queryKey = ({ query, tags }: SearchParams) => [
  "search-results",
  query,
  tags,
];

const hasCriteria = ({ query, tags }: SearchParams) =>
  !!query?.trim() || (tags?.length ?? 0) > 0;

const useSearchResultsQuery = (
  params: SearchParams = {},
  options?: {
    enabled?: boolean;
  },
) => {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKey(params),
    queryFn: () => api.getSearchResults(params),
    ...options,
    enabled: (options?.enabled ?? true) && hasCriteria(params),
  });
};

export const useSearchResultsQueries = (params: SearchParams[]) => {
  const { api } = useApi();

  return useQueries({
    queries: params.map((param) => ({
      queryKey: queryKey(param),
      queryFn: () => api.getSearchResults(param),
      enabled: hasCriteria(param),
    })),
  });
};

export default useSearchResultsQuery;
